<template>
  <Layout>
    <template #header-container>
      <PageHeader :title="title" :sub-title="subTitle">
        <template #afterTitle>
          <div class="d-flex gap-2">
            <McButton
              v-if="activeWizardImport === 'upload-content'"
              variant="secondary"
              icon="icon-outline_arrow-left"
              :text="$t('global.back')"
              @click="$router.push('/fleet-task?type=instant')"
            />

            <template v-if="activeWizardImport === 'result-content'">
              <template v-if="errorResponse">
                <McButton
                  variant="secondary"
                  icon="icon-outline_arrow-left"
                  :text="$t('global.back')"
                  @click="$router.push('/fleet-task?type=instant')"
                />
                <McButton icon="icon-outline_upload" :text="$t('fleetTaskInstant.action.reUpload')" @click="handleReupload" />
              </template>

              <McButton
                v-else
                variant="secondary"
                icon="icon-outline_upload"
                :text="$t('global.action.upload')"
                @click="handleReupload"
              />
            </template>
          </div>
        </template>

        <template #footer>
          <McWizard
            compact
            withNumber
            class="mt-4 mb-4"
            :activeKey="activeWizardImport"
            :items="wizardItems"
          />
        </template>
      </PageHeader>
    </template>

    <!-- Contents -->
    <Upload 
      v-if="activeWizardImport === 'upload-content'" 
      ref="upload-content-ref"
      @upload-file="handleUploadFile" 
    />

    <Process
      v-if="activeWizardImport === 'process-content'"
      :isLoading="isLoading"
      @finish-upload="handleFinishUpload"
    />

    <Result v-if="activeWizardImport === 'result-content'" :error-response="errorResponse" />
  </Layout>
</template>

<script>
import { mapState } from 'vuex'

import appConfig from '@/app.config'
import Layout from '@/router/layouts/main'

import PageHeader from '@/components/page-header-v2'
import McButton from '@/components/McButton'
import McWizard from '@/components/McWizard'

import Upload from './contents/Upload.vue'
import Process from './contents/Process.vue'
import Result from './contents/Result.vue'

import * as Import from '@/services/rest-api/lib/fleet-task-instant/import'

export default {
  page: {
    title: 'Quick Assignment',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    McButton,
    McWizard,
    Upload,
    Process,
    Result,
  },
  data() {
    return {
      activeWizardImport: 'upload-content',
      isLoading: false,
      errorResponse: null,
    }
  },
  computed: {
    ...mapState('fleetTaskInstant', ['importFile']),
    title() {
      return this.$t('fleetTaskInstant.title.upload')
    },
    subTitle() {
      return this.$t('fleetTaskInstant.subtitle.upload')
    },
    wizardItems() {
      return [
        { key: 'upload-content', label: this.$t('global.action.upload'), component: Upload },
        { key: 'process-content', label: this.$t('global.action.process'), component: Process },
        { key: 'result-content', label: this.$t('global.action.result'), component: Result },
      ]
    },
  },
  beforeDestroy() {
    this.$store.dispatch('fleetTaskInstant/setImportFile', undefined)
    this.errorResponse = null
  },
  methods: {
    async handleUploadFile() {
      if (this.importFile === undefined) return

      this.activeWizardImport = 'process-content'
      this.isLoading = true

      const uploadData = { file: this.importFile }
      
      const uploadComponent = this.$refs['upload-content-ref']
      if (uploadComponent?.fullObjects?.userGroup?.id) {
        uploadData.user_group_id = uploadComponent.fullObjects.userGroup.id
      }

      const res = await Import.uploadFile(uploadData)
      
      if (res?.errors_v2) {
        this.errorResponse = res?.errors_v2
      } else if (res?.errors) {
        this.errorResponse = res?.errors
      }

      this.isLoading = false
      this.$store.dispatch('fleetTaskInstant/setImportFile', undefined)
    },

    handleFinishUpload() {
      this.activeWizardImport = 'result-content'
    },

    handleReupload() {
      this.activeWizardImport = 'upload-content'
      this.errorResponse = null
    },
  },
}
</script>

<style lang="scss">
@import '@/design/custom/pages/_fleettaskinstant.scss';
</style>